import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { ServiceOrderList } from '../../serviceOrders/components/ServiceOrderList';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejServiceOrderListPage = () => {
  const { apps, customerType } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej && customerType === 'ipr' ? (
        <AppWrapper
          appType={APP_TYPE.VYDEJ}
          menu={<VydejMenu />}
          resource='ServiceOrders'
          action='list'
        >
          <ServiceOrderList />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejServiceOrderListPage;
